import { OffthreadVideo, useVideoConfig } from "remotion";
import { Filter, VideoItem as VideoItemType } from "../../../types";

export const VideoItem = ({ item }: { item: VideoItemType }) => {
  const renderFilters = (filters: Filter[] | undefined): string => {
    if (!filters || filters.length === 0) {
      return "none";
    }

    const filterStrings = filters.map((filter) => {
      if ((filter.unit === "%" && filter.value === 100) || filter.value === 0) {
        return null;
      }
      return `${filter.type}(${filter.value}${filter.unit})`;
    });

    return filterStrings.filter(Boolean).join(" ");
  };

  if (item.type !== "video") {
    throw new Error("Item is not a video");
  }

  const { fps } = useVideoConfig();

  const videoStyle: React.CSSProperties = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    filter: renderFilters(item.configuration?.filters),
  };

  return (
    <OffthreadVideo
      startFrom={item.videoStartFromInSeconds * fps}
      style={videoStyle}
      src={item.src}
    />
  );
};
